import { useQuery } from '@tanstack/react-query';

import { listCustomerServiceReps, readCustomerServiceRep } from '~/services/LuxLoyalty';

import { customerServiceRepQueryKeys } from './customerServiceRepQueryKeys';

interface UseGetCustomerServiceRepsParams {
  page?: number;
  pageSize?: number;
  enabled?: boolean;
}

/** Fetch a paginated list of customer service reps. */
export function useGetCustomerServiceReps({ page, pageSize, enabled = true }: UseGetCustomerServiceRepsParams = {}) {
  return useQuery({
    queryKey: customerServiceRepQueryKeys.list({ page, pageSize }),
    queryFn: () => listCustomerServiceReps({ page, pageSize }),
    enabled,
    staleTime: 30_000,
  });
}

/** Fetch a single customer service rep by id. */
export function useGetCustomerServiceRep(id: string | null | undefined) {
  return useQuery({
    queryKey: customerServiceRepQueryKeys.detail(id ?? ''),
    queryFn: () => readCustomerServiceRep(id ?? ''),
    enabled: !!id,
    staleTime: 30_000,
  });
}
